<script>
import axios from "axios";
import router from "@/router";
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';

export default {
  page: {
    title: "Volunteer System",
    meta: [
      {
        name: "Volunteer System",
      },
    ],
  },
  props: [
      'userType',
      'location'
  ],
  components: { Header , Footer },
  data(){
    return{
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      locations : null,
      userData: JSON.parse(localStorage.getItem('web_user')),
    }
  },
  mounted(){
    this.getLocations();
    // this.userData = JSON.parse(localStorage.getItem('user'));
  },
  methods: {
    getLocations(){
        axios.get('locations?pagination=true&per_page=1000&status=public&user_type_id=' + this.userData.user_type_id).then(res =>{
          let locations = res.data.response.data;
          this.locations = locations.filter(location => location.status !== 'private');
        })
    },
    landingPage(locationId,locationName){
      var userTypeId = this.userData.user_type_id;
      this.userData.location_id = locationId;
      this.userData.location = locationName;
      localStorage.setItem('web_user', JSON.stringify(this.userData));
      if (userTypeId == '3'){
        router.push({ name: 'mentor-landing'})
      }
      else if(userTypeId == '4'){
        router.push({ name: 'volunteer-landing'})
      }
      else{
        return false
      }
    },
  },
}
</script>

<template>
  <div>
    <Header></Header>
    <section class="page-title">
      <div class="container">
        <div class="row">
          <div class="col">
            <h1 class="title">Become A {{ (userData.user_type_id === 3) ? 'Mentor' : 'Volunteer'}}</h1>
          </div>
        </div>
      </div>
    </section>
    <section class="locations">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <h2 class="title">Select the location where you would like to {{ (userData.user_type_id === 3) ? 'Mentor' : 'Volunteer'}}</h2>
          </div>
          <div class="col-12 text-center" >
            <b-button v-on:click="landingPage(location.id,location.name)" v-for="(location) in locations" :key="location.id" variant="custom">{{location.name}}</b-button>
          </div>
        </div>
      </div>
    </section>
  <Footer></Footer>
  </div>
</template>
